import React from 'react';

const items = [
  '✦ GST Registered Manufacturer',
  '✦ Factory Direct Pricing',
  '✦ Eco-Friendly Materials',
  '✦ Custom Logo Printing',
  '✦ Pan-India Delivery',
  '✦ Minimum Order Available',
  '✦ Fastest Delivery',
];

export default function TrustBar() {
  return (
    <>
      <style>{`
        @keyframes marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .trust-track { animation: marquee 24s linear infinite; }
        .trust-track:hover { animation-play-state: paused; }
      `}</style>
      <div style={s.bar}>
        <div style={s.topLine} />
        <div style={s.overflow}>
          <div className="trust-track" style={s.track}>
            {[...items, ...items].map((item, i) => (
              <span key={i} style={s.item}>{item}</span>
            ))}
          </div>
        </div>
        <div style={s.bottomLine} />
      </div>
    </>
  );
}

const s = {
  bar: { background: '#0f0f0f', position: 'relative', overflow: 'hidden' },
  topLine: { height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,137,58,0.4), transparent)' },
  bottomLine: { height: 1, background: 'linear-gradient(90deg, transparent, rgba(200,137,58,0.4), transparent)' },
  overflow: { overflow: 'hidden', padding: '14px 0' },
  track: { display: 'flex', gap: 0, whiteSpace: 'nowrap', width: 'max-content' },
  item: {
    fontFamily: "'Outfit', sans-serif", fontSize: 12.5, fontWeight: 500,
    color: 'rgba(200,137,58,0.8)', letterSpacing: 1.2, padding: '0 28px',
  },
};
